module.exports = "pegasus_template/assets/preview-21.png";